/* ============================================================
   INKASSO INGO THEME – globales JavaScript
   Warenkorb (Shopify AJAX API), Drawer, Suche, Navigation,
   Akkordeons, Carousel, Sticky-Kaufleiste, Video, Reveals.
   Bewusst schlank, keine Bibliotheken.
   ============================================================ */

function euroCents(cents) {
  return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
}

/* ---------- Overlays ---------- */
let lastFocused = null;
function openOverlay(sel) {
  const ov = document.querySelector(sel);
  if (!ov) return;
  lastFocused = document.activeElement;
  ov.classList.add('is-open');
  document.body.style.overflow = 'hidden';
  const focusable = ov.querySelector('input, button:not([disabled]), a');
  if (focusable) focusable.focus();
}
function closeOverlays() {
  document.querySelectorAll('.mobile-nav, .search-overlay, .cart-drawer, .filter-sheet').forEach(o => o.classList.remove('is-open'));
  document.body.style.overflow = '';
  if (lastFocused) { lastFocused.focus(); lastFocused = null; }
}

/* ---------- Toast ---------- */
let toastTimer;
function toast(msg) {
  let el = document.querySelector('.toast');
  if (!el) {
    el = document.createElement('div');
    el.className = 'toast';
    el.setAttribute('role', 'status');
    document.body.appendChild(el);
  }
  el.textContent = msg;
  el.classList.add('is-visible');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2200);
}

/* ---------- Warenkorb (Shopify AJAX) ---------- */
const CartUI = {
  threshold: 5000, // Cent – wird vom Drawer-Datenattribut überschrieben

  async fetchCart() {
    const res = await fetch('/cart.js');
    return res.json();
  },

  async add(payload) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      toast(err.description || 'Das hat nicht geklappt – versuch es nochmal.');
      throw new Error('add failed');
    }
    await this.render();
    openOverlay('.cart-drawer');
  },

  async change(line, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity }),
    });
    await this.render();
  },

  async render() {
    const cart = await this.fetchCart();

    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count > 0 ? cart.item_count : '';
    });

    const list = document.querySelector('[data-cart-items]');
    if (!list) return cart;

    if (cart.items.length === 0) {
      list.innerHTML = `
        <div class="cart-empty">
          <p class="sticker">${list.dataset.emptyTitle || 'Noch nix drin, Digga.'}</p>
          <p style="margin-top:8px">${list.dataset.emptyText || 'Deine Tüte ist leer. Zeit, das zu ändern.'}</p>
          <p style="margin-top:16px"><a class="btn btn-primary" href="${list.dataset.emptyUrl || '/collections/all'}">${list.dataset.emptyCta || 'Zu den Produkten'}</a></p>
        </div>`;
    } else {
      list.innerHTML = cart.items.map((i, idx) => {
        const props = Object.entries(i.properties || {})
          .filter(([k, v]) => v && !k.startsWith('_'))
          .map(([k, v]) => `${k}: ${v}`).join(' · ');
        return `
        <div class="cart-item">
          <img src="${i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/, '_160x$1$2') : ''}" alt="" width="72" height="72">
          <div>
            <p class="ci-name"><a href="${i.url}" style="text-decoration:none">${i.product_title}</a></p>
            ${i.variant_title && i.variant_title !== 'Default Title' ? `<p class="ci-variant">${i.variant_title}</p>` : ''}
            ${props ? `<p class="ci-variant">${props}</p>` : ''}
            <div class="qty" aria-label="Menge für ${i.product_title}">
              <button type="button" data-qty-change="${idx + 1}:${i.quantity - 1}" aria-label="Menge verringern">−</button>
              <span class="qty-num" aria-live="polite">${i.quantity}</span>
              <button type="button" data-qty-change="${idx + 1}:${i.quantity + 1}" aria-label="Menge erhöhen">+</button>
            </div>
          </div>
          <div>
            <p class="ci-price">${euroCents(i.final_line_price)}</p>
            <button type="button" class="ci-remove" data-qty-change="${idx + 1}:0">Entfernen</button>
          </div>
        </div>`;
      }).join('');
    }

    const subEl = document.querySelector('[data-cart-subtotal]');
    if (subEl) subEl.textContent = euroCents(cart.total_price);

    const shipText = document.querySelector('[data-ship-text]');
    const shipBar = document.querySelector('[data-ship-bar]');
    if (shipText && shipBar) {
      const missing = this.threshold - cart.total_price;
      if (cart.total_price === 0) {
        shipText.innerHTML = `Ab <strong>${euroCents(this.threshold)}</strong> liefern wir gratis (DE).`;
        shipBar.style.width = '0%';
      } else if (missing > 0) {
        shipText.innerHTML = `Noch <strong>${euroCents(missing)}</strong> bis zum Gratis-Versand (DE).`;
        shipBar.style.width = Math.min(100, (cart.total_price / this.threshold) * 100) + '%';
      } else {
        shipText.innerHTML = `<strong>Versand geht auf uns.</strong> Gratis-Versand ist drin.`;
        shipBar.style.width = '100%';
      }
    }

    const checkoutBtn = document.querySelector('[data-checkout]');
    if (checkoutBtn) checkoutBtn.toggleAttribute('disabled', cart.items.length === 0);
    return cart;
  },
};

/* ---------- Initialisierung ---------- */
document.addEventListener('DOMContentLoaded', () => {
  document.documentElement.classList.add('js');

  const drawer = document.querySelector('.cart-drawer');
  if (drawer && drawer.dataset.freeShipping) {
    CartUI.threshold = parseInt(drawer.dataset.freeShipping, 10) * 100;
  }
  CartUI.render();

  // Scroll-Reveals
  if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const autoTargets = document.querySelectorAll('.product-card, .scent-tile, .review-card, .trust-item, .es-media, .club-banner');
    autoTargets.forEach(el => el.classList.add('reveal'));
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.reveal').forEach(el => io.observe(el));
  } else {
    document.querySelectorAll('.reveal').forEach(el => el.classList.add('in'));
  }

  // Overlays / Warenkorb-Klicks
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-open]');
    if (t) { e.preventDefault(); openOverlay(t.getAttribute('data-open')); return; }
    if (e.target.closest('[data-close]')) { closeOverlays(); return; }

    const qc = e.target.closest('[data-qty-change]');
    if (qc) {
      const [line, qty] = qc.dataset.qtyChange.split(':').map(Number);
      CartUI.change(line, qty);
      return;
    }
  });

  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeOverlays(); });

  // Produktformulare per AJAX in den Drawer
  document.querySelectorAll('form[data-ajax-cart]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!form.reportValidity()) return;
      const fd = new FormData(form);
      const properties = {};
      fd.forEach((v, k) => {
        const m = k.match(/^properties\[(.+)\]$/);
        if (m && v) properties[m[1]] = v;
      });
      const payload = {
        items: [{
          id: Number(fd.get('id')),
          quantity: Number(fd.get('quantity') || 1),
          properties: Object.keys(properties).length ? properties : undefined,
        }],
      };
      const btn = form.querySelector('[type="submit"]');
      if (btn) btn.setAttribute('aria-busy', 'true');
      try { await CartUI.add(payload); } catch (err) { /* Toast kam schon */ }
      if (btn) btn.removeAttribute('aria-busy');
    });
  });

  // Akkordeons
  document.querySelectorAll('.accordion-trigger').forEach(btn => {
    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      const panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (panel) panel.hidden = expanded;
    });
  });

  // Carousel-Pfeile
  document.querySelectorAll('[data-carousel]').forEach(wrap => {
    const track = wrap.querySelector('.carousel');
    if (!track) return;
    wrap.querySelector('[data-carousel-prev]')?.addEventListener('click', () => track.scrollBy({ left: -280, behavior: 'smooth' }));
    wrap.querySelector('[data-carousel-next]')?.addEventListener('click', () => track.scrollBy({ left: 280, behavior: 'smooth' }));
  });

  // Sticky-Kaufleiste
  const stickyBuy = document.querySelector('.sticky-buy');
  const buyAnchor = document.querySelector('[data-buy-anchor]');
  if (stickyBuy && buyAnchor && 'IntersectionObserver' in window) {
    document.body.classList.add('has-sticky-buy');
    new IntersectionObserver(([entry]) => {
      stickyBuy.classList.toggle('is-visible', !entry.isIntersecting);
    }, { rootMargin: '-80px 0px 0px 0px' }).observe(buyAnchor);
  }

  // Video-Sektion
  document.querySelectorAll('[data-video-frame]').forEach(frame => {
    const video = frame.querySelector('video');
    const btn = frame.querySelector('[data-video-play]');
    if (!video || !btn) return;
    btn.addEventListener('click', () => {
      frame.classList.add('is-playing');
      video.controls = true;
      video.play();
    });
  });

  // Predictive Search
  const searchInput = document.querySelector('[data-search-input]');
  const searchResults = document.querySelector('[data-search-results]');
  if (searchInput && searchResults) {
    let searchTimer;
    const renderHint = (html) => { searchResults.innerHTML = `<p class="search-hint">${html}</p>`; };
    renderHint('Tipp einfach los – z. B. „Parfum“, „Balm“ oder „Keule“.');
    searchInput.addEventListener('input', () => {
      clearTimeout(searchTimer);
      const q = searchInput.value.trim();
      if (!q) { renderHint('Tipp einfach los – z. B. „Parfum“, „Balm“ oder „Keule“.'); return; }
      searchTimer = setTimeout(async () => {
        try {
          const res = await fetch(`${window.Shopify?.routes?.root || '/'}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8`);
          const data = await res.json();
          const products = data.resources.results.products || [];
          if (products.length === 0) {
            renderHint(`Nix gefunden für „${q}“. <a href="/search?q=${encodeURIComponent(q)}">Alle Ergebnisse ansehen</a>`);
            return;
          }
          searchResults.innerHTML = products.map(p => `
            <a class="search-result" href="${p.url}">
              <img src="${p.featured_image?.url || ''}" alt="" width="56" height="56" loading="lazy">
              <span><strong>${p.title}</strong><br><small style="color:var(--c-muted)">${p.available ? '' : 'Gerade vergriffen'}</small></span>
              <span class="sr-price">${p.price ? p.price + ' €' : ''}</span>
            </a>`).join('') +
            `<p class="search-hint"><a href="/search?q=${encodeURIComponent(q)}">Alle Ergebnisse ansehen →</a></p>`;
        } catch (err) { renderHint('Suche gerade nicht erreichbar.'); }
      }, 250);
    });
    searchInput.closest('form')?.addEventListener('submit', (e) => {
      // normale Suche zulassen (führt zu /search)
    });
  }
});
